export default [
    {
        id: 1,
        title: "CFT Website",
        coverImg: "../images/CFTWebsite.png",
        file: "https://centralfloridatapping.com/",
        description: "Made a company website using CSS, Javascript & Html.",
    },
    {
        id: 2,
        title: "Simulation Project",
        coverImg: "../images/Model4.png",
        file: "./Files/Model4.mp4",
        description: "Created a full manufacturing simulation using C++.",
    },
    {
        id: 3,
        title: "TRG Cost Analysis",
        coverImg: "../images/CostAnalysis.png",
        file: "./Files/TRG_Cost_Analysis.pdf",
        description: "Initial cost analysis study for a gasket company.",
    },
    {
        id: 4,
        title: "CFT Production Analysis",
        coverImg: "../images/Prod_Analysis.png",
        file: "./Files/ProductionAnalysis/tabstrip.htm",
        description: "Time studies for construction production analysis.",
    },
    {
        id: 5,
        title: "Ninder",
        coverImg: "../images/NinderScreen.png",
        file: "/ninder",
        description: "Basically Tinder but it's just me and you can't swipe left.",
    },
    {
        id: 6,
        title: "Github",
        coverImg: "../images/git-pic.jpg",
        file: "https://github.com/Coaxe932",
        description: "See all my GitHub work.",
    },
    {
        id: 7,
        title: "Chat GPT Project",
        coverImg: "../images/GPT-Front.jpg",
        file: "/GPT",
        description: "My version of ChatGPT.",
    },
    {
        id: 8,
        title: "Blog",
        coverImg: "../images/Nick-Blog.jpg",
        file: "/Blog",
        description: "My personal blog.",
    },
    {
        id: 9,
        title: "Date",
        coverImg: "../images/Valentine-Img.jpg",
        file: "/Date",
        description: "Date App.",
    },
    {
        id: 10,
        title: "Date - Spanish",
        coverImg: "../images/Valentine-Img.jpg",
        file: "/Date-Spanish",
        description: "Date App in Spanish.",
    },
    {
        id: 11,
        title: "Location Spoof",
        coverImg: "../images/location.jpg",
        file: "/LocationSpoof",
        description: "GPS Spoof App.",
    },
    {
        id: 12,
        title: "Cafe Ai",
        coverImg: "../images/location.jpg",
        file: "/CafeAi",
        description: "Cafe AI Project.",
    },
    {
        id: 13,
        title: "El Carancho — Sistema de Puntos",
        coverImg: "../images/Meat.png",
        file: "/ElCarancho",
        description: "Sistema de puntos y recompensas para una carnicería moderna.",
    },
];
